import {BaseBlock, theme} from "../../../framework/js/core";

export class Footer extends BaseBlock {
  constructor(root) {
    super(root);
    // this.compensateHeight();
    // $(window).on("resize", () => this.compensateHeight());
  }
  
  compensateHeight() {
    theme.root.css("margin-bottom", this.root.outerHeight());
  }
}